module.exports = __webpack_public_path__ + "img/alipay.fde1ae4e.svg";